import { render, staticRenderFns } from "./GroupMembersTable.vue?vue&type=template&id=5084b34c&scoped=true"
import script from "./GroupMembersTable.vue?vue&type=script&lang=js"
export * from "./GroupMembersTable.vue?vue&type=script&lang=js"
import style0 from "./GroupMembersTable.vue?vue&type=style&index=0&id=5084b34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5084b34c",
  null
  
)

export default component.exports